import { Box, Button, Dialog, IconButton, Stack, Typography } from '@mui/material'
import FeatherIcon from 'feather-icons-react'
import type { EditDialogProps } from '../types'

export const EditDialog = ({ isOpen, title, children, onClose, onSave, isDisabled }: EditDialogProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <Box sx={{ padding: '32px', paddingBottom: '24px' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
          <Typography variant="h6">{title}</Typography>
          <IconButton size="small" onClick={onClose} data-testid="modal-close-button">
            <FeatherIcon icon="x" size={16} />
          </IconButton>
        </Stack>
      </Box>
      <Box sx={{ padding: '32px', paddingTop: '16px' }}>
        <Stack width="100%" spacing="32px">
          {children}
        </Stack>
        <Stack>
          <Button
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
            variant="contained"
            color="success"
            onClick={onSave}
            disabled={isDisabled}
          >
            Save
          </Button>
          <Button
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
            variant="outlined"
            color="error"
            onClick={onClose}
          >
            Close
          </Button>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default EditDialog
